import { ClientPersistedState } from './clientpersistedstate-types';

// these defaults only get used/set if the user has no persisted state
const defaults: ClientPersistedState = {
  userListColumnOrder: ['name', 'username', 'admin', 'status']
};

export default defaults;
